import store from '@/store.js'

const statusNew = 'new'
const statusEingestellt = 'eingestellt'
const statusWarteliste = 'warteliste'
const statusAbgesagt = 'abgesagt'
const statusVerified = 'verified'

const status = {}
status[statusNew] = {
  transitions: [statusEingestellt, statusWarteliste, statusAbgesagt, statusVerified],
  label: 'Inbox',
  value: statusNew,
  permission: void 0
}
status[statusEingestellt] = {
  transitions: [statusNew],
  label: 'Einzustellen',
  value: statusEingestellt,
  permission: _ => store.getters['hasPermissionToFinalizeCandidate']
}
status[statusWarteliste] = {
  transitions: [statusNew, statusAbgesagt, statusEingestellt, statusVerified],
  label: 'Warteliste',
  value: statusWarteliste,
  permission: void 0
}
status[statusAbgesagt] = {
  transitions: [statusNew],
  label: 'Abgesagt',
  value: statusAbgesagt,
  permission: void 0
}
status[statusVerified] = {
  transitions: [statusNew, statusAbgesagt, statusEingestellt, statusWarteliste],
  label: 'Geprüft',
  value: statusVerified,
  permission: void 0
}

const statusBL = {
  states: {
    'STATUS_NEW': statusNew,
    'STATUS_RECRUITED': statusEingestellt,
    'STATUS_WAITING': statusWarteliste,
    'STATUS_CANCELLED': statusAbgesagt,
    'STATUS_VERIFIED': statusVerified
  },

  getPossibleStatesForCandidate (candidate) {
    const currentStatus = this.getStatusForCandidate(candidate)

    if (!currentStatus) {
      return [currentStatus]
    }

    const possibleStates = currentStatus.transitions
      .map(key => status[key])
      .filter(status => {
        const permissionFn = typeof status.permission === 'function' ? status.permission : _ => true
        return permissionFn()
      })

    return [].concat(currentStatus, possibleStates)
  },

  getStatusForCandidate (candidate) {
    return candidate && candidate.metadata
      ? status[candidate.metadata.status]
      : void 0
  },

  setStatusForCandidate (candidate, status) {
    const activated = status.value === statusNew
    store.commit('updateStatusForCandidate', {
      candidate,
      status,
      activated
    })
  },

  getCandidateFilterOptions () {
    const possibleFilterOptions = [statusNew, statusWarteliste, statusEingestellt, statusAbgesagt, statusVerified]
    const filterOptions = possibleFilterOptions.map(filterStatus => {
      return {
        status: filterStatus,
        label: status[filterStatus].label,
        value: status[filterStatus].value
      }
    })
    filterOptions.push({
      status: 'all',
      label: 'Alle',
      value: 'all'
    })
    return filterOptions
  }

  // statusRequiresMandatoryAnswers (status) {
  //   const key = typeof status === 'object'
  //     ? status.value
  //     : status

  //   return key === statusEingestellt
  // },

  // statusRequiresVerifications (status) {
  //   const key = typeof status === 'object'
  //     ? status.value
  //     : status

  //   return key === statusEingestellt
  // }
}

export default statusBL
